/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Card, List, Tag, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, NavLink } from "react-router-dom";

import InfiniteScroll from "react-infinite-scroll-component";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";

const UpComingActivities = ({ activities, userFullName, companyName }) => {
  console.log("activitiesactivitiesactivities",activities)
  const [data, setData] = useState(activities);
  const navigate = useNavigate();
  const { id } = useParams();
  // console.log("#########################", activities.activityId);
  const [selectedIds, setSelectedIds] = useState([]);
  // console.log(selectedIds);
  const handleCheckboxChange = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((itemId) => itemId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };
  useEffect(() => {
    setData(activities);
  }, [activities]);

  const handleDeleteSelected = () => {
    const newData = data.filter(
      (item) => !selectedIds.includes(item.activityId)
    );
    setData(newData);
    setSelectedIds([]);
  };
  const handleShowDeleted = () => {
    setData(activities);
    setSelectedIds([]);
  };
  const handleDeleteActivity = async (activityId, index) => {
    const newData = data.filter((item) => item.activityId !== id);
    setData(newData);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const activityDocRef = doc(companyDocRef, "activities", activityId);

      // Fetch the document by its ID
      const activityDoc = await getDoc(activityDocRef);
      if (!activityDoc.exists()) {
        console.error("Activity document does not exist!");
        return;
      }

      const activityData = activityDoc.data();

      // Remove the activity at the desired index
      if (
        activityData.propertiesActivities &&
        activityData.propertiesActivities.length > index
      ) {
        activityData.propertiesActivities.splice(index, 1);
      }

      // Update the document in Firestore with the modified data
      await updateDoc(activityDocRef, activityData);
      console.log("Activity deleted successfully!");
    } catch (error) {
      console.error("Error deleting activity: ", error);
    }
  };

  const handleNewKeys = () => {
    navigate(`/activity/new_activity/${id}`);
  };

  const allActivites = data?.length > 0 ? data[0]?.propertiesActivities : [];

  return (
    <div>
      <Card
        extra={
          <Button onClick={handleNewKeys}>
            <i
              className="fa-solid fa-circle-plus"
              style={{ marginRight: "5px" }}
            ></i>{" "}
            Add Activity
          </Button>
        }
      >
        <div
          id="scrollableDiv"
          style={{
            maxHeight: 200,
            overflow: "auto",
            padding: "0 16px",
            border: "1px solid rgba(140, 140, 140, 0.35)",
          }}
        >
          <InfiniteScroll
            dataLength={data?.length}
            scrollableTarget="scrollableDiv"
          >
            <List
              dataSource={allActivites}
              renderItem={(item, index) => (
                <List.Item key={item?.dateTime}>
                  <Checkbox
                    checked={selectedIds.includes(item?.activityId)}
                    onChange={() => handleCheckboxChange(item?.activityId)}
                    style={{ marginRight: "15px" }}
                  />
                  <List.Item.Meta
                    title={
                      <NavLink
                        // to={`/activity/new_activity/${data[0]?.activityId}?edit=${index}`}
                        style={
                          selectedIds.includes(item?.activityId)
                            ? { color: "gray" }
                            : { color: "red" }
                        }
                      >
                        {item?.activityDate}
                      </NavLink>
                    }
                    description={
                      <>
                        <NavLink
                          // to={`/activity/new_activity/${data[0]?.activityId}?edit=${index}`}
                          style={
                            selectedIds.includes(item?.activityId)
                              ? { color: "gray" }
                              : { color: "red" }
                          }
                        >
                          {item?.Description}
                        </NavLink>
                        (Assigned to:
                        {userFullName})
                      </>
                    }
                  />
                  <Tag
                    color={
                      selectedIds.includes(item?.activityId) ? "gray" : "red"
                    }
                  >
                    {item?.activityLabel}
                  </Tag>
                  <Button
                    type="text"
                    onClick={() =>
                      handleDeleteActivity(data[0]?.activityId, index)
                    }
                  >
                    <i
                      className="fa-solid fa-circle-minus"
                      style={{ color: "red" }}
                    ></i>
                  </Button>
                </List.Item>
              )}
            />
          </InfiniteScroll>
        </div>
        {/* <div style={{ textAlign: "center" }}>
          {selectedIds.length > 0 && (
            <Button type="link" onClick={handleDeleteSelected}>
              Hide Completed Activities
            </Button>
          )}
          {data.length < activities.length && (
            <Button type="link" onClick={handleShowDeleted}>
              Show Completed Activities
            </Button>
          )}
        </div> */}
      </Card>
    </div>
  );
};

export default UpComingActivities;
